import React from 'react';
import { Link } from 'react-router-dom';
import './NotFound.css';

const NotFound = () => {
  return (
    <div className="not-found-container">
      <div className="not-found-content">
        <div className="not-found-code-wrapper">
          <span className="not-found-digit">4</span>
          <img src="/logo.webp" alt="0" className="not-found-logo-inline" />
          <span className="not-found-digit">4</span>
        </div>
        <h2 className="not-found-title">Page Not Found</h2>
        <Link to="/" className="btn btn-primary not-found-btn">
          Back to Home
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
